import tonStyles from './../ton.json'

export default {
  border: `solid 1px ${tonStyles.colors.SecondaryGreySteel}`,
  nameColor: tonStyles.colors.PrimaryBlack,
  descriptionColor: tonStyles.colors.SecondaryGreySky,
  priceColor: tonStyles.colors.PrimaryBlack,
  salePriceColor: tonStyles.colors.SecondaryRed,
  badge: {
    type: 'Label',
    name: '3',
    color: tonStyles.colors.SecondaryGreySky
  },
  consideredBadge: {
    type: 'Paragraph',
    name: '6',
    color: tonStyles.colors.ConsideredGreen,
    border: `solid 1px ${tonStyles.colors.ConsideredGreen}`,
    borderRadius: '4px'
  }
}
